import VIcon from './index.vue';

export default {
  install: (Vue) => Vue.component('VIcon', VIcon),
};
